import { gql } from '@apollo/client';

import { StudentMediaSessionActivity } from '@ts-core/modules/billing/types';

export interface GetStudentMediaSessionsByMonthQueryVariables {
  courseId: string;
  studentId: string;
  year: string;
  month: string;
}

export interface GetStudentMediaSessionsByMonthQueryResult {
  mediaSessions: StudentMediaSessionActivity[];
}

export const getStudentMediaSessionsByMonthQuery = gql`
  query GetStudentMediaSessionsByMonthQuery($courseId: String!, $studentId: String!, $year: String!, $month: String!) {
    mediaSessions(courseId: $courseId, studentId: $studentId, year: $year, month: $month)
      @rest(
        type: "StudentMediaSessionActivityByMonth"
        path: "students-activity/years/{args.year}/months/{args.month}/courses/{args.courseId}/students/{args.studentId}/media-sessions"
      ) {
      _id
      platform
      maxProgressPercentage
      lastEventDate
      createdAt
      video
    }
  }
`;
